export enum DatadogAutoLoginMessage {
  DETECTED_BASE_PAGE_VISIT = "Autologin: detected base page visit",
  FAILED = "Autologin: failed",
  STARTED = "Autologin: started",
}
